<template>
  <div>
    <div>
      <Loader v-if="isLoadingSalaryCodes" :bg-color="'#fff'"></Loader>
      <table class="do-table do-table__items" v-else>
        <thead>
        <th>Titel</th>
        <th>Kode</th>
        <th>
          <button class="do-bttn do-bttn--submit" @click="setIsCreateItemModal(true)">
            Opret lønkode
          </button>
        </th>
        </thead>
        <tbody>
        <tr v-if="items.length === 0">
          <td colspan="2">
            <i>Ingen oprettet</i>
          </td>
          <td>
          </td>
        </tr>
        <tr v-for="item in items" :key="item.code">
          <td>{{ item.name }}</td>
          <td>{{ item.code }}</td>
          <td>
            <!-- TODO CREATE EDIT METHOD
            <div class="icon__bg-circle" @click="setEditItem(item)">
              <span class="icon-pencil"></span>
            </div>
            -->
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <TableCreateModal
      v-if="isCreateItemModal"
      :theEditItem="theEditItem"
      :isSubmitting="isSubmitting"
      :isDeleting="isDeleting"
      @close="setIsCreateItemModal"
      @onSubmit="onCreate">
    </TableCreateModal>
  </div>
</template>

<script>
import TableCreateModal from './TableCreateModal.vue'
import docendo from '../../../docendo'
import Loader from '../../common/Loader.vue'

export default {
  components: {Loader, TableCreateModal},
  data () {
    return {
      isCreateItemModal: false,
      theEditItem: null,
      isSubmitting: false,
      isDeleting: false
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    },
    items () {
      return this.salaryCodes
    },
    salaryCodes () {
      return this.$store.getters.salaryCodesSorted
    },
    isLoadingSalaryCodes () {
      return this.$store.state.employments.isLoadingSalaryCodes
    }
  },
  methods: {
    setIsCreateItemModal (bool) {
      this.isCreateItemModal = bool
      if (!bool) {
        this.theEditItem = null
      }
    },
    setEditItem (item) {
      this.theEditItem = item
      this.isCreateItemModal = true
    },
    onCreate (obj) {
      const schoolId = this.schoolId
      const name = obj.title
      const loenart = obj.code
      const tillaegsnummer = ''
      this.isSubmitting = true
      console.log({ schoolId, name, loenart, tillaegsnummer })
      docendo.createSalaryCode(schoolId, name, loenart, tillaegsnummer, success => {
        this.isSubmitting = false
        this.$store.dispatch('readSalaryCodes')
      }, failure => {
        this.isSubmitting = false
      })
    }
  },
  mounted () {
    this.$store.dispatch('readSalaryCodes')
  }
}
</script>

<style scoped>
.do-table__items {
  max-width: 600px;
}

.do-table__items tbody tr:nth-child(2n) {
  background-color: #f9fafb;
}

.do-table__items tbody tr {
  border-bottom: 1px solid #eee;
}

.do-table__items tr:hover {
  background-color: aliceblue !important;
}

.do-table__items th:last-child {
  text-align: right;
}

.do-table__items tr > td:last-child {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// SalaryCodes.vue?b0a75e8c